<template>
  <div class="nav2Box z1200">
    <div class="top_set">
      <a href="user?index=0">通行证首页</a>
      <span> >推广中心</span>
    </div>
    <div class="topmsg">
      <div class="list1">
        <div class="list_tip">
          推广收益
        </div>
        <div class="list_left">
          <svg-icon icon-class="shouru" />
          <span>{{ userData1.surplusIncome }}</span>
        </div>
        <p class="list_right">
          <svg-icon icon-class="jifenduoge" />
          <span class="span2" style="color: #68CA77">{{ userData1.integraIncome }}</span>
        </p>
      </div>
      <div class="list1">
        <div class="list_tip">
          推广成效
        </div>
        <div class="list_left">
          <span>{{ userData1.registerSize }}</span><span style="font-size: 14px;color: #999">人注册</span>
        </div>
        <p class="list_right">
          <span style="color: #F9C071">{{ userData1.consumeSize }}</span><span style="font-size: 14px;color: #999">人次消费</span>
        </p>
      </div>
      <div class="list1" style="width: 400px;">
        <span class="sharemsg">分享我的推广链接</span>
        <svg-icon icon-class="erweima" class="svgsty" />
      </div>
    </div>

    <!--<div class="tips">-->
    <!--推广明细-->
    <!--</div>-->
    <div class="tbox">
      <div class="tbox1 tbox_content">
        <div class="tbox_1">
          推广产品
        </div>
        <div class="tbox_2">
          要求
        </div>
        <div class="tbox_3">
          收益
        </div>
        <div class="tbox_4">
          推广链接
        </div>
      </div>
      <div class="tbox2 tbox_content">
        <div class="tbox_1">
          <img :src="showlist1" alt="">
        </div>
        <div class="tbox_2">
          <span class="tbox_2_1">用户每日登录</span>
          <span class="tbox_2_1">注册新用户</span>
          <span class="tbox_2_1">消费</span>
          <span class="tbox_2_1">推广用户购买版本</span>
          <span class="tbox_2_1_2">推广用户注册</span>
        </div>
        <div class="tbox_3">
          <span class="tbox_2_1">+10 积分</span>
          <span class="tbox_2_1">+100 积分</span>
          <span class="tbox_2_1">每消费1元获得10积分</span>
          <span class="tbox_2_1">10%消费金额</span>
          <span class="tbox_2_1_2">+100 积分</span>
        </div>
        <div class="tbox_4">
          <span class="tbox_4_span">微信扫一扫分享给好友<svg-icon icon-class="shouzhiyou" /></span>
          <div class="codeimgs">
            <img :src="codeimg" alt="">
            <div class="codeShadow">
              <img :src="code1" alt="">
            </div>
          </div>
          <div class="tbox_4_div">
            <p><span>{{ userMsg.nickname }}</span>推荐你使用大谱师；免费注册，立即使用！</p>
            <p>3分钟轻松上手，10分钟创建并出版家谱！</p>
            <p>http://maker.myfamilybook.cn?relativeMen='{{ userMsg.passportid }}</p>
          </div>
          <div style="margin-top: 20px;">
            <span class="tbox_4_btn copyBtn" :data-clipboard-text="msg" @click="goCopy(1)">复制链接分享给好友</span>
          </div>
        </div>
      </div>
      <div class="tbox3 tbox_content">
        <div class="tbox_1">
          <img :src="showlist2" alt="">
        </div>
        <div class="tbox_2">
          <span class="tbox_2_1">用户每日登录</span>
          <span class="tbox_2_1">注册新用户</span>
          <span class="tbox_2_1">消费</span>
          <span class="tbox_2_1">推广用户购买版本</span>
          <span class="tbox_2_2">推广用户注册</span>
        </div>
        <div class="tbox_3">
          <span class="tbox_2_1">+10 积分</span>
          <span class="tbox_2_1">+100 积分</span>
          <span class="tbox_2_1">每消费1元获得10积分</span>
          <span class="tbox_2_1">10%消费金额</span>
          <span class="tbox_2_2">+100 积分</span>
        </div>
        <div class="tbox_4">
          <span class="tbox_4_span">微信扫一扫分享给好友<svg-icon icon-class="shouzhiyou" /></span>
          <div class="codeimgs">
            <img :src="codeimg" alt="">
            <div class="codeShadow">
              <img :src="code2" alt="">
            </div>
          </div>
          <div class="tbox_4_div">
            <p><span>{{ userMsg.nickname }}</span>推荐你使用大谱师；免费注册，立即使用！</p>
            <p>3分钟轻松上手，10分钟创建并出版家谱！</p>
            <p>http://www.myfamilybook.cn/#125455</p>
          </div>
          <div style="margin-top: 9px">
            <span class="tbox_4_btn">复制链接分享给好友</span>
          </div>
        </div>
      </div>
    </div>
    <div class="box_content">
      <div class="tips">
        推广明细
      </div>
      <div class="controlBox">
        <div class="controlBox_div1">
          <span class="tipsname">事件时间：</span>
          <div class="select1">
            <el-date-picker
              v-model="NowData1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="changeTime1"
            />
          </div>
          <span class="tipsname">最近</span>
          <span :class="timetypeindex==1?'btn_type1_avtive':'btn_type1'" @click="timeBtn1(1)">一周</span>
          <span :class="timetypeindex==2?'btn_type1_avtive':'btn_type1'" @click="timeBtn1(2)">一月</span>
          <span :class="timetypeindex==3?'btn_type1_avtive':'btn_type1'" @click="timeBtn1(3)">一年</span>
          <div class="select2">
            <span>按月选择 <svg-icon icon-class="sanjiaoxia" /></span>
            <div class="selectInput">
              <el-date-picker
                v-model="NowData2"
                type="month"
                placeholder="按月选择"
                @change="changeTime2"
              />
            </div>
          </div>
          <span class="tipsname" style="margin-left: 15px">推广类型：</span>
          <span :class="shouzhitypeindex==-1?'btn_type1_avtive':'btn_type1'" @click="changewalletType(-1)">全部</span>
          <span :class="shouzhitypeindex==1?'btn_type1_avtive':'btn_type1'" @click="changewalletType(1)">注册</span>
          <span :class="shouzhitypeindex==2?'btn_type1_avtive':'btn_type1'" @click="changewalletType(2)">消费</span>
          <!--<div class="btn_type2">-->
          <!--<span v-if="thistype" @click="thistype=false">高级筛选 <svg-icon icon-class="sanjiaoxia" /></span>-->
          <!--<span v-if="!thistype" @click="thistype=true">基本筛选 <svg-icon icon-class="sanjiaoshang" /></span>-->
          <!--</div>-->
        </div>
        <!--<div v-show="!thistype" class="controlMore">-->
        <!--<div class="controlMore_lis">-->
        <!--<span class="tipsname">收支类型：</span>-->
        <!--<span :class="shouzhitypeindex==-1?'btn_type1_avtive':'btn_type1'" @click="changewalletType(-1)">全部</span>-->
        <!--<span :class="shouzhitypeindex==1?'btn_type1_avtive':'btn_type1'" @click="changewalletType(1)">收入</span>-->
        <!--<span :class="shouzhitypeindex==2?'btn_type1_avtive':'btn_type1'" @click="changewalletType(2)">支出</span>-->
        <!--</div>-->
        <!--<div class="controlMore_lis controlMore_lis2">-->
        <!--<span class="tipsname">交易类型：</span>-->
        <!--<span v-for="(item,index) in jiaoyiType" :key="index" @click="changetradeType(item,index)">-->
        <!--<span v-show="item.type==-1||item.type==shouzhitypeindex||shouzhitypeindex==-1" :class="tradeTypeindex==index?'btn_type1_avtive':'btn_type1'">{{ item.name }}</span>-->
        <!--</span>-->
        <!--</div>-->
        <!--<div class="controlMore_lis controlMore_lis2" style="height: 40px;">-->
        <!--<span class="tipsname">关键字：</span>-->
        <!--<div class="inputSearch">-->
        <!--<el-input v-model="searchKey" placeholder="请输入交易编号，交易描述关键字" />-->
        <!--<span class="iconsearch" @click="changeData">-->
        <!--<svg-icon icon-class="sousuo" />-->
        <!--</span>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </div>
    <div class="box_list">
      <TableTemolate :option="option" :columns="columns" :selection="false" data-type="publicityDetails" />
    </div>
  </div>
</template>

<script>
import { loadIndex, loadPublicity, getPassportJointatQRcode, getPassportUserReaderQRcode } from '@/api/api.js'
import TableTemolate from '@/components/passcardNav/tableTemolate.vue'
export default {
  components: {
    TableTemolate
  },
  inject: ['reload'],
  data() {
    return {
      code2: '',
      code1: '',
      userMsg: {},
      msg: '',
      codeimg: require('@/static/codeimg.png'),
      showlist1: require('@/static/dapushi1.png'),
      showlist2: require('@/static/puyue1.png'),
      searchKey: '',
      timetypeindex: 1,
      shouzhitypeindex: -1,
      tradeTypeindex: 0,
      thistype: true,
      userData1: {},
      listData: [],
      NowData1: '',
      NowData2: '',
      option: {
        pageSize: 10,
        ajax: {
          url: '/passportPublicity/findPublicityDetails', // /获取列表数据的地址
          type: 'post'
        },
        param: {
          passportid: '',
          index: 1,
          size: 10,
          startDate: '', // /始
          endDate: '', // 末
          publicityType: ''
        }
      },
      columns: [
        { 'prop': 'PUBLICITY_ID', label: '推广编号', width: '300px' },
        { 'prop': 'CREATE_DATE', label: '推广时间', width: '180px' },
        { 'prop': 'NICKNAME', label: '推广用户', width: '80px' },
        { 'prop': 'PUBLICITY_TYPE', label: '推广类型', width: '100px' },
        { 'prop': 'PUBLICITY_DESC_CONTENT', label: '推广描述', width: '200px' },
        { 'prop': 'PROFIT_AMOUNT', label: '收益', width: '60px' },
        { 'prop': 'PROFIT_TYPE', label: '收益类型', width: '120px' },
        { 'prop': 'SYSTEM_CODE', label: '平台', width: '100px' }
      ]
    }
    // /初始化数据
  },
  mounted() {
    new ClipboardJS('.copyBtn')
    this.fetchData()
    // this.imgCutUploadParams.param.userId = this.getLoca('userid')
    // console.log(dataJson)
    // this.countryData = dataJson.dataJson
  },
  methods: {
    fetchData() {
      loadIndex().then(res => {
        this.option.param.passportid = res.data.passportUser.passportid
        this.setloca('passportid', res.data.passportUser.passportid, 7200)
        getPassportJointatQRcode({ passportid: res.data.passportUser.passportid }).then(res => {
          this.code1 = res.data.link
        })
        getPassportUserReaderQRcode({ passportid: res.data.passportUser.passportid }).then(res => {
          this.code2 = res.data.link
        })
        this.userMsg = res.data.passportUser
        this.msg = res.data.passportUser.nickname + '推荐你使用大谱师；免费注册，立即使用！3分钟轻松上手，10分钟创建并出版家谱http://maker.myfamilybook.cn?relativeMen=' + this.getLoca('passportid')
        loadPublicity({ passportid: this.option.param.passportid, index: 1, size: 5 }).then(res => {
          this.userData1 = res.data
        })
      })
    },
    changeData() {
      this.option.param.str = this.searchKey
    },
    changeTime1(data) {
      console.log(data)
      this.option.param.startDate = data[0]
      this.option.param.endDate = data[1]
    },
    changeTime2(data) {
      var year = data.getFullYear()
      var month = data.getMonth() + 1
      var d = new Date(year, month, 0)
      this.option.param.endDate = year + '-' + month + '-' + d.getDate()
      this.option.param.startDate = year + '-' + month + '-' + '01'
      this.NowData1 = []
      this.NowData1.push(this.option.param.startDate)
      this.NowData1.push(this.option.param.endDate)
    },
    timeBtn1(type) {
      this.timetypeindex = type
      var data = new Date()
      var year = data.getFullYear()
      var month = data.getMonth() + 1
      var day = data.getDate()
      this.option.param.endDate = year + '-' + month + '-' + day
      if (type == 1) {
        if (day >= 7) {
          this.option.param.startDate = year + '-' + month + '-' + (day - 6)
        } else {
          if (month > 1) {
            var d = new Date(year, month - 1, 0)
            this.option.param.startDate = year + '-' + (month - 1) + '-' + (d.getDate() - 6) + day
          } else {
            year--
            var d2 = new Date(year, 12, 0)
            this.option.param.startDate = year + '-' + '12' + '-' + (d2.getDate() - 6) + day
          }
        }
      }
      if (type == 2) {
        if (month > 1) {
          month--
        } else {
          year--
          month = 12
        }
        this.option.param.startDate = year + '-' + month + '-' + day
      }
      if (type == 3) {
        this.option.param.startDate = (year - 1) + '-' + month + '-' + day
      }
    },
    changewalletType(type) {
      this.shouzhitypeindex = type
      if (type != -1) {
        if (type == 1) {
          this.option.param.publicityType = '2c9e80676d1e4dd7016d1f4a66ef002c'
        }
        if (type == 2) {
          this.option.param.publicityType = '2c9e80676d1e4dd7016d1f4b1fee002d'
        }
      } else {
        this.option.param.publicityType = ''
      }
    },
    goCopy(type) {
      if (type == 1) {
        this.$message({
          type: 'success',
          message: '复制成功，快去分享给你的好友吧！'
        })
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .tbox{
    border: 1px solid #E1E8F1;
    .tbox1{
      height: 68px;
      background-color: #F1F7FF;
      text-align: center;
      line-height: 68px;
      div{
        font-size: 16px;
        color: #333333;
      }
    }
    .tbox2{
      /*height: 235px;*/
      overflow: hidden;
      background-color: #FFFFFF;
      text-align: center;
      .tbox_1{
        line-height: 294px;
        img{
          vertical-align: middle;
        }
      }
      .tbox_2_1{
        font-size: 14px;
        color: #333;
        height: 58px;
        line-height: 58px;
        display: inline-block;
        width: 100%;
        vertical-align: top;
        border-bottom: 1px solid #E1E8F1;
      }
      .tbox_2_1_2{
        font-size: 14px;
        color: #333;
        height: 58px;
        line-height: 58px;
        display: inline-block;
        width: 100%;
        vertical-align: top;
      }
      .tbox_4{
        text-align: center;
        overflow: hidden;
        height: 294px;
        .codeimgs{
          display: inline-block;
          width: 45px;
          height: 45px;
          float: right;
          cursor: pointer;
          position: relative;
          img{
            width: 45px;
            height: 45px;
          }
          .codeShadow{
            position: absolute;
            top: 295px;
            left: -353px;
            transition: 1s;
            width: 398px;
            height: 294px;
            text-align: center;
            line-height: 294px;
            background-color: #F3F3F4;
            img{
              vertical-align: middle;
              width: 150px;
              height: 150px;
            }
          }
        }
        .codeimgs:hover > .codeShadow{
          top: 0;
        }
      }
      .tbox_4_div{
        margin-top: 20px;
        width: 294px;
        padding: 15px 22px;
        background-color: #F6FAFF;
        display: inline-block;
        border: 1px solid #E1E8F1;
        p{
          text-align: left;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
      .tbox_4_btn{
        display: inline-block;
        width: 178px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
        border: 1px solid #EC90A8;
        cursor: pointer;
        color: #E0466E;
      }
      .tbox_4_span{
        .clipboardswf{
          position:absolute;
          left:0;
          top:0;
        }
        position: relative;
        display: inline-block;
        height: 45px;
        line-height: 45px;
        color: #999999;
        vertical-align: top;
        margin-left: 178px;
        svg{
          color: #C4DCFE;
          font-size: 30px;
          vertical-align: -0.6rem;
          margin-left: 5px;
        }
      }
    }
    .tbox3{
      overflow: hidden;
      background-color: #FFFFFF;
      text-align: center;
      .tbox_1{
        line-height: 294px;
        img{
          vertical-align: middle;
        }
      }
      .tbox_2_1{
        font-size: 14px;
        color: #333;
        height: 58px;
        line-height: 58px;
        display: inline-block;
        width: 100%;
        vertical-align: top;
        border-bottom: 1px solid #E1E8F1;
      }
      .tbox_2_2{
        font-size: 14px;
        color: #333;
        height: 58px;
        line-height: 58px;
        display: inline-block;
        width: 100%;
        vertical-align: top;
      }
      .tbox_4{
        text-align: center;
        overflow: hidden;
        height: 294px;
        .codeimgs{
          display: inline-block;
          width: 45px;
          height: 45px;
          float: right;
          cursor: pointer;
          img{
            width: 45px;
            height: 45px
          }
          .codeShadow{
            position: absolute;
            top: 0px;
            left: 0px;
            transition: 1s;
            width: 398px;
            height: 294px;
            text-align: center;
            line-height: 294px;
            background-color: #F3F3F4;
            img{
              vertical-align: middle;
              width: 150px;
              height: 150px;
            }
          }
        }
        .codeimgs:hover > .codeShadow{
          top: 0;
        }
      }
      .tbox_4_div{
        width: 294px;
        padding: 10px 22px;
        background-color: #F6FAFF;
        display: inline-block;
        border: 1px solid #E1E8F1;
        p{
          text-align: left;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
      .tbox_4_btn{
        display: inline-block;
        width: 178px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
        border: 1px solid #EC90A8;
        cursor: pointer;
        color: #E0466E;
      }
      .tbox_4_span{
        display: inline-block;
        height: 45px;
        line-height: 45px;
        color: #999999;
        vertical-align: top;
        margin-left: 178px;
        svg{
          color: #C4DCFE;
          font-size: 30px;
          vertical-align: -0.6rem;
          margin-left: 5px;
        }
      }
    }
    .tbox_content{
      width: 100%;
      border-bottom: 1px solid #E1E8F1;

    }
    .tbox_1{
      width: 248px;
      border-right: 1px solid #E1E8F1;
      display: inline-block;
      vertical-align: top;
      height: 100%;
    }
    .tbox_2{
      width: 350px;
      border-right: 1px solid #E1E8F1;
      display: inline-block;
      vertical-align: top;
      height: 100%;
    }
    .tbox_3{
      width: 198px;
      border-right: 1px solid #E1E8F1;
      display: inline-block;
      vertical-align: top;
      height: 100%;
    }
    .tbox_4{
      width: 398px;
      display:inline-block;
      vertical-align: top;
      height: 100%;
      position: relative;
    }
  }
    .z1200{
        width: 1200px;
        margin: 0 auto;
    }
    .nav2Box{
        overflow: hidden;
        min-height: 100vh;
        .top_set{
            height: 80px;
            line-height: 80px;
            text-align: left;
            font-size: 14px;
            a{
                color: #999999;
            }
            span{
                color: #666666;
            }
        }
        .topmsg{
            background-color: #fff;
            overflow: hidden;
            margin-bottom: 10px;
           border-left: 1px solid #EEEEEE;
           border-top: 1px solid #EEEEEE;
           border-bottom: 1px solid #EEEEEE;
          text-align: center;
            .list1{
                display: inline-block;
                vertical-align: top;
                width: 398px;
                border-right: 1px solid #EEEEEE;
                padding: 30px 0;
              .sharemsg{
                height: 40px;
                line-height: 40px;
                display: inline-block;
                vertical-align: top;
                padding: 20px 0;
                padding-right: 50px;
                font-size: 16px;
                color: #e0466e;
                cursor: pointer;
              }
              .svgsty{
                font-size: 40px;
                vertical-align: top;
                padding: 20px 0;
                color: #C4DCFE;
              }
              .list_tip{
                text-align: center;
                font-size: 18px;
                color: #333;
                height: 30px;
                line-height: 30px;
                margin-bottom: 20px;
              }
                .list_left{
                    display: inline-block;
                    width: 160px;
                    height: 30px;
                    text-align: center;
                    line-height: 30px;
                    vertical-align: top;
                    svg{
                        color: #666666;
                        font-size: 28px;
                       vertical-align: -0.4rem;
                    }
                  span{
                    font-size: 20px;
                    color: #e3003a;
                    margin-left: 5px;
                  }
                }
                .list_right{
                    width: 160px;
                    height: 30px;
                    display: inline-block;
                    vertical-align: top;
                    text-align: center;
                  svg{
                    color: #666666;
                    font-size: 28px;
                    vertical-align: -0.4rem;
                  }
                  span{
                    font-size: 20px;
                    color: #e3003a;
                    margin-left: 5px;
                  }
                }
            }
            .list_last{
                display: inline-block;
                vertical-align: top;
                width: 296px;
                height: 50px;
                line-height: 50px;
                span{
                    background-color: #F3F8FF;
                    padding: 5px 15px;
                    border: 1px solid #BCD4F5;
                    color: #666666;
                    border-radius: 3px;
                    cursor: pointer;
                    font-size: 14px;
                }
            }
        }
        .box_content{
            background-color: #fff;
            padding: 20px 30px;
            overflow: hidden;
            padding-top: 0px;
           margin-top: 40px;
        }
        .tips{
            display: inline-block;
            padding-left: 7px;
            border-left: 3px solid #E0466E;
            height: 17px;
            line-height: 17px;
            margin-top: 30px;
            font-size: 18px;
        }
        .controlBox{
            background-color: #F1F7FF;
            padding: 20px 30px;
            margin-top: 25px;
            .tipsname{
                color: #999;
                font-size: 14px;
            }
            .controlBox_div1{
                height: 35px;
                line-height: 35px;
                .select1{
                    display: inline-block;
                    width: 315px;
                    vertical-align: top;
                    margin-right: 45px;
                    height: 35px;
                }
                .select2{
                    width: 80px;
                    position: relative;
                    display: inline-block;
                    vertical-align: top;
                    margin-left: 12px;
                    overflow: hidden;
                    cursor: pointer;
                    .selectInput{
                        width: 80px;
                        opacity: 0;
                        position: absolute;
                        left: 0;
                        top: 0;
                        cursor: pointer;
                    }
                    span{
                        color: #999999;
                    }
                }
                .btn_type2{
                    display: inline-block;
                    vertical-align: top;
                    margin-left: 130px;
                    span{
                        font-size: 14px;
                        color: #E0466E;
                        cursor: pointer;
                    }
                }
            }
            .btn_type1{
                padding: 5px 15px;
                border: 1px solid #E5E5E5;
                border-radius: 3px;
                color: #333333;
                font-size: 14px;
                background-color: #fff;
                margin-left: 15px;
                cursor: pointer;
            }
            .btn_type1_avtive{
                padding: 5px 15px;
                border: 1px solid #E0466E;
                border-radius: 3px;
                color: #ffffff;
                font-size: 14px;
                background-color: #E0466E;
                margin-left: 15px;
                cursor: pointer;
            }
            .controlMore{
                overflow: hidden;
                margin-top: 22px;
                .controlMore_lis{
                    height: 32px;
                    line-height: 32px;
                }
                .controlMore_lis2{
                    margin-top: 15px;
                    .inputSearch{
                        margin-left: 27px;
                        position: relative;
                        width: 300px;
                        display: inline-block;
                        vertical-align: top;
                        .iconsearch{
                            position: absolute;
                            right: 8px;
                            top: 7px;
                            cursor: pointer;
                            svg{
                                font-size: 26px;
                                color: #E0466E;
                            }
                        }
                    }
                }
            }
        }
        .box_list{
            background-color: #fff;
            padding-left: 30px;
            padding-right: 30px;
            padding-bottom: 30px;
        }
    }

</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {

    }
</style>

